import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { v4 } from 'uuid'

import { Button } from '@/shared'
import { type IAdditionalInfo2 } from '@App/types/doctorsType'

import { type IAction, type IAdditionalInfo2Editable } from '../helper'

import style from './Description.module.scss'
import { SectionItem } from './SectionItem/SectionItem'

interface IProps {
    additionalInfo: IAdditionalInfo2[]
    onUpdateAdditionalInfo: (dto: IAdditionalInfo2[], onSuccess?: () => void) => void
    onGetAdditionalInfoActualData: (onSuccess?: () => void) => void
}

export const Description = (props: IProps) => {
    const { additionalInfo, onUpdateAdditionalInfo, onGetAdditionalInfoActualData } = props

    const onSetReadTypeForAllItems = () => setData((prev) => prev.map((item) => ({ ...item, itemType: 'read' })))

    const [data, setData] = useState<IAdditionalInfo2Editable[]>(
        additionalInfo.map((item) => ({ ...item, itemType: 'read', id: v4() }))
    )

    useEffect(() => {
        setData(additionalInfo.map((item) => ({ ...item, itemType: 'read', id: v4() })))
    }, [additionalInfo])

    const onUpdateAdditionalInfoHandler = () => {
        const dto = data.map(({ id, itemType, ...rest }) => rest)
        onUpdateAdditionalInfo(dto, onSetReadTypeForAllItems)
    }

    const onRemoveAdditionalInfoHandler = (sectionId: string) => {
        const filteredData = data.filter((item) => item.id !== sectionId)
        const dto = filteredData.map(({ id, itemType, ...rest }) => rest)
        onUpdateAdditionalInfo(dto, () => setData(filteredData))
    }

    const onAddNewItem = () => {
        setData((prev) => [...prev, { title: '', items: [], itemType: 'create', id: v4() }])
    }

    if (data.length < 1) {
        return (
            <div className={style.emptyDescription}>
                <span>Информация отсутствует</span>
                <Button onClick={onAddNewItem}>Добавить информацию</Button>
            </div>
        )
    }

    const actions: IAction[] = [
        {
            title: 'Добавить описание к карточке',
            callback: onAddNewItem,
            className: 'blue'
        }
    ]

    return (
        <div className={style.container}>
            {/* <BlurApp show={!!newSection} /> */}
            {data.map((additionalInfoSection) => (
                <SectionItem
                    key={additionalInfoSection.id}
                    setData={setData}
                    onUpdateAdditionalInfo={onUpdateAdditionalInfoHandler}
                    onRemoveAdditionalInfo={onRemoveAdditionalInfoHandler}
                    onGetAdditionalInfoActualData={onGetAdditionalInfoActualData}
                    {...additionalInfoSection}
                />
            ))}
            {/* <button onClick={onAddNewItem}>Добавить информацию</button> */}
            <div className={style.actions}>
                {actions.map((action, idx) => {
                    const { title, callback, className } = action
                    return (
                        <Button key={idx} className={classNames(style.btn, style[className])} onClick={callback}>
                            {title}
                        </Button>
                    )
                })}
            </div>
        </div>
    )
}
